import React from 'react';
import MaterialTableContainer from '@mui/material/TableContainer';
import type {TableContainerProps as MaterialTableContainerProps} from '@mui/material/TableContainer';
import {styled} from '@mui/material/styles';
import {Card} from '../Card/Card';
import {excludeComponentProps} from '../utils/excludeComponentProps';

export interface TableContainerProps extends MaterialTableContainerProps {
    /**
     * Variants of TableContainer
     */
    variant?: 'elevated' | 'outlined';
    /**
     * Used to replace root node with different
     * component. If variant is elevated, this
     * is set to the Card component.
     */
    component?: React.ElementType<any>;
}

const StyledTableContainer = styled(MaterialTableContainer, {
    ...excludeComponentProps('variant')
})<TableContainerProps>(({
    theme, variant
}) => ({
    ...(variant === 'elevated' || variant === 'outlined') && {
        '& tbody tr:last-child td, & tbody tr:last-child th': {
            border: 0
        }
    },
    ...variant === 'outlined' && {
        border: `1px solid ${theme.tokens.FuelColorBorderLight}`,
        borderRadius: theme.tokens.FuelBorderRadiusLg
    }
}));

export const TableContainer = React.forwardRef<any, TableContainerProps>(({
    children, component, variant, ...props
},
ref
) => (
    <StyledTableContainer
        component={variant === 'elevated' ? Card : component}
        ref={ref}
        variant={variant}
        {...props}
    >
        {children}
    </StyledTableContainer>
));

TableContainer.displayName = 'TableContainer';
